import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import Typography from '@mui/material/Typography';
import { TabContent } from './BottomTabs';

const DialPadNumbers = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
  ['*', 0, '#'],
];

function phoneFormat(input) {
  input = input.replace(/\D/g, '');
  const size = input.length;
  if (size > 0) {
    input = '(' + input;
  }
  if (size > 3) {
    input = input.slice(0, 4) + ') ' + input.slice(4, 11);
  }
  if (size > 6) {
    input = input.slice(0, 9) + '-' + input.slice(9);
  }
  return input;
}

const DialPad = ({
  onDial,
  value,
  onChange,
  canDial,
  mode = 'dialer',
  onClose,
}) => {
  const handleChange = (val) => {
    if (mode === 'dialer') {
      onChange(value + val);
    } else {
      onChange(val);
    }
  };

  const handleDial = () => {
    onDial(value);
  };

  return (
    <TabContent onClose={onClose} title="Dial Pad">
      <Box mx="auto">
        {DialPadNumbers.map((row, index) => (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            spacing={1}
            justifyContent="space-between"
            mb={1}
          >
            {row.map((number) => (
              <Button
                fullWidth
                variant="outlined"
                key={number}
                onClick={() => handleChange(number)}
              >
                <Typography variant="h3" fontWeight={500}>
                  {number === '*' ? '﹡' : number}
                </Typography>
              </Button>
            ))}
          </Stack>
        ))}
        {onDial && (
          <Box textAlign="center">
            <Button
              fullWidth
              disabled={!canDial}
              variant="contained"
              onClick={handleDial}
            >
              <CallIcon sx={{ color: 'white' }} />
            </Button>
          </Box>
        )}
      </Box>
    </TabContent>
  );
};

export default DialPad;
